// ← → between chats without handling them (owner, 2026-10-30, agent-v2 DASHBOARD).
//
// « ← → arrows (swipe on phone, keyboard keys) to move to prev/next chat
// without handling it. » In the order of the list on screen. Pure, for its test.
//
// Guard: chatNav.test.ts
import { AXIS_LOCK_PX, EDGE_PX } from '../swipe';

export type Step = 'next' | 'prev';

/** The chat before/after `current` in `ids`, or null at either end. Not listed → next is the first. */
export function neighbourChat(ids: ReadonlyArray<string>, current: string | null, step: Step): string | null {
  if (!ids.length) return null;
  const i = current ? ids.indexOf(current) : -1;
  if (i < 0) return step === 'next' ? ids[0] : null;
  const j = step === 'next' ? i + 1 : i - 1;
  return j >= 0 && j < ids.length ? ids[j] : null;
}

/**
 * Arrow keys belong to whatever is being typed in — never steal them there —
 * and to the controls that use them themselves (a video's seek bar, a menu,
 * the page's tabs).
 */
export function isTypingTarget(el: EventTarget | null | undefined): boolean {
  const e = el as (HTMLElement & { isContentEditable?: boolean }) | null | undefined;
  if (!e || typeof e !== 'object' || !('tagName' in e)) return false;
  const tag = String(e.tagName).toUpperCase();
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || tag === 'VIDEO' || tag === 'AUDIO') return true;
  if (e.isContentEditable) return true;
  return typeof e.closest === 'function'
    && Boolean(e.closest('[role="menu"],[role="listbox"],[role="slider"],[role="tablist"],[role="radiogroup"]'));
}

/** The key → a step, or null (modifiers, other keys). */
export function keyStep(e: Pick<KeyboardEvent, 'key' | 'altKey' | 'ctrlKey' | 'metaKey' | 'shiftKey'>): Step | null {
  if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return null;
  return e.key === 'ArrowRight' ? 'next' : e.key === 'ArrowLeft' ? 'prev' : null;
}

/**
 * A finished swipe on the phone chat → a step, or null.
 *
 *   · EDGE   a touch that starts in the left 24 px is the shell's swipe-back.
 *   · AXIS   clearly sideways: |dx| at least twice |dy| (a scroll stays a scroll).
 *   · FAR    at least 30 % of the screen (min 80 px).
 *
 * Finger to the left = the next chat (the page turns), to the right = the previous.
 */
export function swipeStep(startX: number, dx: number, dy: number, width: number): Step | null {
  if (startX < EDGE_PX) return null;
  const ax = Math.abs(dx);
  if (ax < AXIS_LOCK_PX || ax < 2 * Math.abs(dy)) return null;
  if (ax < Math.max(80, width * 0.3)) return null;
  return dx < 0 ? 'next' : 'prev';
}
